import React from 'react';
import { Input } from 'alurkerja-ui';
import { FormField, IFormField } from './FormField';

type InputType = 'text' | 'password' | 'hidden' | 'date' | 'number';

interface InputFieldProps extends IFormField {
  type?: InputType;
  step?: number;
}

export const InputField: React.FC<InputFieldProps> = props => {
  return (
    <FormField
      className={props.type === 'hidden' ? 'hidden' : ''}
      {...props}
      render={({ field }) => (
        <Input
          id={props.name}
          defaultValue={field.value}
          onChange={e => field.onChange(e.target.value)}
          type={props.type ?? 'text'}
          disabled={props.disabled}
          placeholder={props.placeholder}
          step={props.type === 'number' ? props.step : undefined}
        />
      )}
    />
  );
};
